import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';

export default makeStyles(
  (theme: Theme) =>
    createStyles({
      textField: {
        width: '100%'
      },
      textFieldHelperText: {
        display: 'flex',
        justifyContent: 'space-between',
      },
      textFieldHelperTextItem: {
        marginLeft: 10,
        '&:first-child': {
          marginLeft: 0
        }
      },
      confirmButtom: {
        marginTop: '50px',
        textAlign: 'right'
      },
    }),
  {
    name: 'IncluirPerguntaChatModal',
  }
);
